<mat-nav-list>
  <mat-list-item>
    <h3 mat-dialog-title> Aktionstatus ändern </h3>
  </mat-list-item>
  <div *ngFor="let state of list">
    <mat-list-item role="listitem" *ngIf="this.data.event.state != state.value" (click)="changeState(state.value)">
      {{state.viewValue}}
    </mat-list-item>
  </div>
</mat-nav-list>